import api from './api';

const publicService = {
  // Get all insurance plans (public endpoint)
  async getInsurancePlans(apiKey = null) {
    try {
      const config = {};
      if (apiKey) {
        config.headers = { 'x-api-key': apiKey };
      }
      const response = await api.get('/public/insurance-plans', config);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get all healthcare providers (public endpoint)
  async getProviders(apiKey = null) {
    try {
      const config = {};
      if (apiKey) {
        config.headers = { 'x-api-key': apiKey };
      }
      const response = await api.get('/public/providers', config);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default publicService;
